import { call, put } from "redux-saga/effects"
import { SET_REFRESH_TOKEN, SET_LOGIN_ERROR, SET_LOG_OUT_USER } from "../actions"
import * as firebase from 'firebase/app';
import 'firebase/auth';

export function* loginSaga(action) {
    try {
        const { email, password } = action.values
        const auth = firebase.auth()
        const response = yield call(
            [auth, auth.signInWithEmailAndPassword],
            email,
            password
        )
        yield put({
            type: SET_REFRESH_TOKEN,
            response,
            submitted: true,
            error: false,
            success: true
        })
    }
    catch (response) {
        // console.log("error", response)
        yield put({
            type: SET_LOGIN_ERROR,
            response,
            submitted: true,
            error: true,
            success: false

        })
    }
}
export function* logOutSaga() {
    try {
        localStorage.clear()
        // const auth = firebase.auth()
        // yield call(
        //     [auth, auth.signOut])
        yield put({
            type: SET_LOG_OUT_USER,
        })
    }
    catch (error) {
        yield put({
            type: SET_LOG_OUT_USER,
        })
    }

}